module.exports = __webpack_public_path__ + "static/gallery29-400deb6d989d04be3fa4411a1eb4586a.png";